<template>
  <div id="xxportx_csv"></div>
</template>

<script>
export default {
  name: 'Export_CSV',
  CsvExport: function (data, fields, fieldNames, fileName) {
    try {
      var result = json2csv({
        data: data,
        fields: fields,
        fieldNames: fieldNames,
      })
      // var csvContent = 'data:text/csvcharset=utf-8,\uFEFF' + result

      var csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + result
      var encodedUri = encodeURI(csvContent)

      const fixedEncodedURI = encodedUri.replaceAll('#', '%23')
      var link = document.createElement('a')
      link.setAttribute('href', fixedEncodedURI)
      link.setAttribute('download', `${fileName || 'file'}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error(err)
    }
  },
}
</script>

<style scoped></style>
